import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';

function Faqedit() {
    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
  
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    let { id } = useParams();
  
    const [faq, setFaq] = useState([]);
  
    const [formerror, setError] = useState({});
  
    const getinfo = async (e) => {
      const res = await fetch(`${Config.apiurl}/api/v1/crm/faq/get-faq/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      });
      if (res.status === 200 ) {
        const data = await res.json();
  
        setFaq(data.data);
  
      } 
      else if(res.status === 401){
        handleUnauthorized();
        getinfo();
      }
      else {
        alert("error");
  
      }
    };
  
    let name, value;
  
    const handleInputs = (e) => {
      console.log(e);
      name = e.target.name;
      value = e.target.value;
      setFaq({ ...faq, [name]: value });
    };
  
   
  
    const validate = (values) => {
      const errors = {};
      if (!values.faqBody) {
        errors.faqBody = "Question is required!";
      }
  
      if (!values.faqTitle) {
        errors.faqTitle = "Answer is required!";
      }
      
      return errors;
    };
    const PostData = async (e) => {
      e.preventDefault();
      const ress = validate(faq);
      setError(ress);
      if (!ress.faqTitle && !ress.faqBody ) {
      
        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/faq/update-faq-info/${id}`,
            {
            method: "PUT",
            body: JSON.stringify({
                faqTitle: faq.faqTitle,
                faqBody: faq.faqBody,
                status: faq.status,
              }),
      
              headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
                "Content-type": "application/json; charset=UTF-8",
              },
          })
          if (res.status === 200 ) {
            const data = await res.json();
  
              toast.success("Sucessfully updated Faq", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setTimeout(() => navigate("/dashboard"), 3000);
      
            } 
            else if(res.status === 401){
              handleUnauthorized();
              PostData();
            }
  
            else {
              toast.error("Something went wrong", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
        
      }
    };
    useEffect(() => {
      getinfo();
    }, []);
    return (
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Advertisement</h4>
                      <p className="card-description">New Ads</p>
                      <form className="forms-sample" onSubmit={PostData}>
                        {/* <form className="forms-sample"> */}
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Title"
                            name="faqTitle"
                            value={faq.faqTitle}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.faqTitle}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Link</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Link"
                            name="faqBody"
                            value={faq.faqBody}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>{formerror.faqBody}</label>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Status</label>
  
                            <select
                              className="form-control "
                              style={{
                                color: "black",
                                backgroundColor: "#2b2e4c;",
                              }}
                              id="exampleInputUsername1"
                              name="status"
                              onChange={handleInputs}
                              value={faq.status}
                            >
                              <option {...(faq.status === "1" ? "selected" : "")}>
                                true
                              </option>
                              <option {...(faq.status === "0" ? "selected" : "")}>
                                false
                              </option>
                            </select>
                          </div>
                        </div>
  
                    
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  

export default Faqedit
